<template>
  <div class="test pad">
    <button class="button" @click="test">TEST</button>

    <div v-for="item in items" :key="item._id" class="flex border-ccc pad-5">
      <div class="flex-1 pad-5">{{ item.firstName }}</div>
      <div class="flex-1 pad-5">{{ item.lastName }}</div>
      <div class="flex-2 pad-5">{{ item.active }}</div>
    </div>

  </div>
</template>

<style lang="css">
</style>

<script>
export default {
  name: 'Test',
  components: {},
  data () {
    return {
      items: []
    }
  },
  computed: {
    user () { return this.$store.getters.user }
  },
  created () {
    this.$fs.collection('users')
      .onSnapshot(ss => {
        this.items = this.$ssToArr(ss)
      })
  },
  methods: {
    async test () {
      // const ss = await this.$fs.collection('users').get()
      // const items = this.$ssToArr(ss)
      // const batch = this.$fs.batch()
      // for (const item of items) {
      //   batch.update(this.$fs.doc(`/users/${item._id}`), { active: true })
      // }
      // await batch.commit()
    }
  }
}
</script>

<style>
</style>
